import ProgressBar from '../progress-bar'

interface Props {
  page:
    | 'order'
    | 'refund-method'
    | 'return-method'
    | 'confirm'
    | 'return-address'
  title: string
}

const TopBar: React.FC<Props> = ({ page, title }) => {
  return (
    <div>
      <div className="h-12 rounded-t-3xl bg-white"></div>
      <div
        id="TopBar"
        className="sticky top-0 z-10 flex w-full bg-white pt-4 shadow-[0_4px_6px_-1px_rgba(0,_0,_0,_0.1),_0_2px_4px_-2px_rgba(0,_0,_0,_0.1)]"
      >
        <div className="h-full py-0.5 pl-4 pr-0.5 lg:w-[245px] xl:w-[400px]"></div>
        <div className="grow">
          <h5 className="mb-2 text-center">{title}</h5>
          <ProgressBar page={page} />
        </div>
        <div className="lg:w-[245px] xl:w-[400px]" />
      </div>
    </div>
  )
}

export default TopBar
